import { onCLS, onINP, onLCP, onFCP, onTTFB } from 'web-vitals';

/**
 * Web Vitals reporter — sends Core Web Vitals metrics to GA4.
 * CLS (Cumulative Layout Shift), INP (Interaction to Next Paint),
 * LCP (Largest Contentful Paint), FCP (First Contentful Paint), TTFB.
 */
function sendToGA4({ name, delta, id, rating }) {
  if (typeof window !== 'undefined' && window.gtag) {
    window.gtag('event', name, {
      value: Math.round(name === 'CLS' ? delta * 1000 : delta),
      metric_id: id,
      metric_value: Math.round(name === 'CLS' ? delta * 1000 : delta),
      metric_rating: rating,
      event_category: 'Web Vitals',
      non_interaction: true,
    });
  }
}

export function reportWebVitals() {
  onCLS(sendToGA4);
  onINP(sendToGA4);
  onLCP(sendToGA4);
  onFCP(sendToGA4);
  onTTFB(sendToGA4);
}
